import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { AnnouncementActionEvent } from '@bonusly/common-announcements';
import { MegaphoneOutline } from '@bonusly/design-system';
import { useDispatch } from '@bonusly/events';

import { IconAndTextContent } from './icon-and-text-content';
import { UserNavAction } from './user-nav-action';

interface AnnouncementMenuItemProps {
	isExpanded: boolean;
	onClose: () => void;
}

export const AnnouncementMenuItem: FC<AnnouncementMenuItemProps> = ({ isExpanded, onClose }) => {
	const { t } = useTranslation('navigation');
	const dispatch = useDispatch();

	const handleClick = () => {
		dispatch(AnnouncementActionEvent.OpenAnnouncement);
		onClose();
	};

	return (
		<UserNavAction onClick={handleClick} label={t('links.announcements')} isExpanded={isExpanded} data-testid="nav-link-announcements">
			<IconAndTextContent icon={<MegaphoneOutline size="md" />} label={t('links.announcements')} isExpanded={isExpanded} />
		</UserNavAction>
	);
};
